// extracted by mini-css-extract-plugin
module.exports = {"Watch":"Watch","Watch__active":"Watch__active"};